// src/components/ResponderRutinas.js
import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  TextField,
  Grid,
  Paper,
  Button,
  MenuItem,
  Alert
} from '@mui/material';

import api from './api';
import Header from './Header';
import { StyledMainContainer } from './StyleComponents';
import { useParams } from 'react-router-dom';
import CameraCapture from './CameraCapture';
import { useNavigate } from 'react-router-dom';
import useCameraPermission from './CameraPermission'; // o la ruta donde lo coloques





function ResponderRutinas() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [preguntas, setPreguntas] = useState([]);
  const [errores, setErrores] = useState({});
  const [loading, setLoading] = useState(true);
   const { status: camStatus, request: requestCamPermission, error: camError } = useCameraPermission();
const handleFileFallback = (idx, e) => {
    const file = e.target.files?.[0];
    if (file) {
      handleChange(idx, 'valor', file);
    }
  };

  useEffect(() => {
    const fetchRutinaRespuestas = async () => {
      try {
        const resRutina = await api.get(`/rutinas/${id}`);
        const respuestas = (resRutina.data.respuestas || [])
          .slice()
          .sort((a, b) => {
            // Si el backend ya manda created_at en la respuesta, ordena por ahí
            if (a.created_at && b.created_at) {
              return new Date(a.created_at) - new Date(b.created_at);
            }
            return 0; // deja el orden tal cual si no existe created_at
          });


        const preguntasConDetalles = await Promise.all(respuestas.map(async (respuesta) => {
          const resPregunta = await api.get(`/preguntas_rutinas/${respuesta.pregunta_rutina_id}`);
          //console.log('Pregunta cargada:', resPregunta.data);

          const pregunta = resPregunta.data;

          const lista_opciones = (pregunta.lista || []).map(item => item.nombre);




          return {
            respuesta_id: respuesta.id,
            pregunta_id: pregunta.id,
            enunciado: pregunta.pregunta,
            tipo: (pregunta.tipo_respuesta?.tipo || '').toLowerCase(),
            lista_opciones: (pregunta.lista || []).map(item => item.nombre),
            valor: '',
            observacion: '',
            mostrarCamara: false,
            orden: (pregunta.orden ?? pregunta.posicion ?? null),
            pregunta_created_at: pregunta.created_at || null,
            respuesta_created_at: respuesta.created_at || null,
          };

        }));

        //setPreguntas(preguntasConDetalles);
        const ordenadas = preguntasConDetalles.slice().sort((a, b) => {
        // 1) Si hay un campo numérico de orden/posicion, úsalo
         if (a.orden != null && b.orden != null) return a.orden - b.orden;
         // 2) Si no, ordena por fecha de creación de la pregunta
         if (a.pregunta_created_at && b.pregunta_created_at) {
           return new Date(a.pregunta_created_at) - new Date(b.pregunta_created_at);
         }
         // 3) Fallback: por fecha de creación de la respuesta
         if (a.respuesta_created_at && b.respuesta_created_at) {
           return new Date(a.respuesta_created_at) - new Date(b.respuesta_created_at);
         }
         return 0;
       });
       setPreguntas(ordenadas);
        setLoading(false);
      } catch (error) {
        console.error('Error cargando rutina y preguntas:', error);
        setLoading(false);
      }
    };

    fetchRutinaRespuestas();
  }, [id]);

  const handleChange = (index, campo, valor) => {
    setPreguntas(prev => {
      const updated = [...prev];
      updated[index][campo] = valor;
      if (campo === 'valor' && updated[index].tipo === 'foto' && valor) {
           updated[index].mostrarCamara = false;
         }
      return updated;
    });
    if (errores[index]) {
      setErrores(prev => ({ ...prev, [index]: false }));
    }
  };

  const handleSubmit = async () => {
  const nuevosErrores = {};
  let valido = true;

  for (let i = 0; i < preguntas.length; i++) {
    if (!preguntas[i].valor) {
      nuevosErrores[i] = true;
      valido = false;
    }
  }
  setErrores(nuevosErrores);

  if (!valido) {
    alert('Por favor completa todos los campos obligatorios');
    return;
  }

  let todasExitosas = true;

  for (const pregunta of preguntas) {
    try {
      let response;
      if (pregunta.tipo === 'foto') {
        const formData = new FormData();
        formData.append('id', pregunta.respuesta_id);
        formData.append('rutina_id', id);
        formData.append('pregunta_rutina_id', pregunta.pregunta_id);
        formData.append('observaciones', pregunta.observacion || '');
        formData.append('is_active', 'true');
        formData.append('file', pregunta.valor);

        response = await api.post(`/respuestas_rutinas/upload_foto/`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
      } else {
        response = await api.put(`/respuestas_rutinas/${pregunta.respuesta_id}`, {
          rutina_id: id,
          pregunta_rutina_id: pregunta.pregunta_id,
          respuesta: pregunta.valor,
          observaciones: pregunta.observacion || '',
          is_active: true
        });
      }

      if (!(response.status >= 200 && response.status < 300)) {
        throw new Error(`Respuesta fallida con código ${response.status}`);
      }

    } catch (err) {
      todasExitosas = false;
      console.error(`Error en pregunta: ${pregunta.enunciado}`, err);
      alert(`Error al enviar la respuesta de: ${pregunta.enunciado}`);
      break;
    }
  }

  if (!todasExitosas) {
    return; // Si hubo error, NO sigue
  }

  try {
    const rutinaResp = await api.get(`/rutinas/${id}`);
    const rutina = rutinaResp.data;

    const rutinaUpdateResp = await api.put(`/rutinas/${id}`, {
      tipo_rutina_id: rutina.tipo_rutina_id,
      planta_id: rutina.planta_id,
      fecha_inicio: rutina.fecha_inicio,
      fecha_fin: rutina.fecha_fin,
      nombre: rutina.nombre,
      status: 'respondida'
    });

    if (!(rutinaUpdateResp.status >= 200 && rutinaUpdateResp.status < 300)) {
      throw new Error('Error al actualizar la rutina');
    }

    alert('Respuestas enviadas con éxito');
    navigate('/rutinas');

  } catch (err) {
    console.error('Error al actualizar rutina:', err);
    alert('Las respuestas se enviaron, pero no se pudo actualizar la rutina.');
  }
};



  return (
    <StyledMainContainer>
      <Header />
      <Typography variant="h5" gutterBottom>
        Responder Rutina
      </Typography>

      {loading ? <p>Cargando preguntas...</p> : (
        <Paper elevation={1} sx={{ p: 1, borderRadius: '8px' }}>

          {/* Aviso global si la cámara está denegada */}
          {camStatus === 'denied' && (
            <Box sx={{ mb: 2 }}>
              <Alert severity="warning">
                La cámara está bloqueada por el navegador. Toca “Permitir cámara” para reintentar.
                Si vuelve a fallar, habilítala desde los permisos del sitio en tu navegador.
              </Alert>
            </Box>
          )}
          {camError && (
            <Box sx={{ mb: 2 }}>
              <Alert severity="error">{camError}</Alert>
            </Box>
          )}

          {preguntas.map((pregunta, idx) => (
            <Grid container spacing={1} key={pregunta.pregunta_id} sx={{ mb: 3 }}>
              {/* Contenedor para el campo de respuesta (pregunta.enunciado y su input/select/etc.) */}
              <Grid size={{ xs: 12, sm: 6 }}> {/* En móvil (xs) ocupa todo el ancho, en sm y superior, la mitad */}
                <Typography variant="body1" sx={{ mb: 1, fontWeight: 'medium' }}>
                  {pregunta.enunciado}
                </Typography>

                {pregunta.tipo === 'libre' || pregunta.tipo === 'numero' ? (
                  <TextField
                    fullWidth
                    variant="outlined"
                    type={pregunta.tipo === 'numero' ? 'number' : 'text'}
                    value={pregunta.valor}
                    onChange={(e) => handleChange(idx, 'valor', e.target.value)}
                    error={errores[idx]}
                    helperText={errores[idx] ? 'Campo obligatorio' : ''}
                  />
                ) : pregunta.tipo === 'lista' ? (
                  <TextField
                    select
                    fullWidth
                    variant="outlined"
                    value={pregunta.valor}
                    onChange={(e) => handleChange(idx, 'valor', e.target.value)}
                    error={errores[idx]}
                    helperText={errores[idx] ? 'Selecciona una opción' : ''}
                  >
                    <MenuItem value="">Seleccione una opción</MenuItem>
                    {pregunta.lista_opciones.map((op, i) => (
                      <MenuItem key={i} value={op}>{op}</MenuItem>
                    ))}
                  </TextField>
                ) : pregunta.tipo === 'foto' ? (
            <>
              {!pregunta.valor ? (
                <>
                  {camStatus === 'granted' ? (
                    // Con permiso -> mostrar "Tomar foto" (abre CameraCapture)
                    <>
                      {!pregunta.mostrarCamara ? (
                        <Button
                          variant="outlined"
                          onClick={() => {
                            const nuevas = [...preguntas];
                            nuevas[idx].mostrarCamara = true;
                            setPreguntas(nuevas);
                          }}
                        >
                          Tomar foto
                        </Button>
                      ) : (
                        <CameraCapture
                          onCapture={(file) => {
                            handleChange(idx, 'valor', file);
                            const nuevas = [...preguntas];
                            nuevas[idx].mostrarCamara = false;
                            setPreguntas(nuevas);
                          }}
                        />
                      )}
                    </>
                  ) : (
                    // SIN permiso -> 2 opciones: reintentar permiso + fallback input file
                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>
                      <Button variant="outlined" onClick={requestCamPermission}>
                        Permitir cámara
                      </Button>

                      {/* Fallback que funciona incluso con permiso bloqueado */}
                      <label>
                        <input
                          type="file"
                          accept="image/*"
                          capture="environment"
                          style={{ display: 'none' }}
                          onChange={(e) => handleFileFallback(idx, e)}
                        />
                        {/*<Button variant="outlined" component="span">
                          Subir foto
                        </Button>*/}
                      </label>
                    </Box>
                  )}

                  {/* Tips según estado */}
                  {camStatus !== 'granted' && (
                    <Typography variant="caption" display="block" sx={{ mt: 1 }}>
                      Si “Permitir cámara” no aparece, habilita el permiso del sitio:
                      <br />
                      <strong>Android (Chrome):</strong> Toca el candado en la barra → Permisos → Cámara → Permitir,
                      o Menú ⋮ → Configuración → Configuración de sitios → Cámara.
                      <br />
                      <strong>iPhone (Chrome/Safari):</strong> Ajustes del iPhone → {`{Chrome o Safari}`} → Cámara → Permitir,
                      o en la página toca el botón “aA / candado” → Configuración del sitio → Cámara → Permitir.
                    </Typography>
                  )}
                </>
              ) : (
                <Box>
                  <Typography variant="body2" sx={{ mb: 1 }}>Foto capturada:</Typography>
                  <img
                    src={URL.createObjectURL(pregunta.valor)}
                    alt="Previsualización"
                    style={{ maxWidth: '100%', maxHeight: 200 }}
                  />
                  <Box mt={1} sx={{ display: 'flex', gap: 1 }}>
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={() => handleChange(idx, 'valor', null)}
                    >
                      Retomar foto
                    </Button>
                  </Box>
                </Box>
              )}
            </>
          )  : null}
              </Grid>


              <Grid size={{ xs: 12, sm: 6 }}> {/* En móvil (xs) ocupa todo el ancho, en sm y superior, la mitad */}
                <TextField
                  label="Observaciones"
                  fullWidth
                  multiline
                  rows={3}
                  value={pregunta.observacion}
                  onChange={(e) => handleChange(idx, 'observacion', e.target.value)}
                />
              </Grid>
            </Grid>
          ))}


          <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
            <Button variant="contained" color="primary" onClick={handleSubmit}>
              Enviar Respuestas
            </Button>
          </Box>
        </Paper>
      )}
    </StyledMainContainer>
  );
}

export default ResponderRutinas;
